import React from 'react';
import Popup from "reactjs-popup";
import Contact from "./Contact";
import About from "./About";
import News from "./News";
import Subscribe from "./Subscribe";
import PackGroupContents from "./PackGroupContents";
import './Modal.css';
import Lightbox from "react-awesome-lightbox";
import "react-awesome-lightbox/build/style.css";
import { useParams } from 'react-router-dom'

const Modal = ({hideModal, isShowing, type}) => {
  const [ lightboxImage, setLightboxImage ] = React.useState("");
  const [ lightboxTitle, setLightboxTitle ] = React.useState("");
  const routeParams = useParams()
  
  const showcaseLightbox = (img, title) =>{
    setLightboxImage(img);
    setLightboxTitle(title);
  }

  const endCoverShowcase= () => {
    setLightboxImage("");
    setLightboxTitle("");
  }

    let modalContent;
    if (type === 'contact') {
      modalContent = <Contact/>
    }else if(type === 'about') {
      modalContent = <About/>
    }else if(type === 'news') {
      modalContent = <News/>
    }else if(type === 'subscribe') {
      modalContent = <Subscribe/>
    }else if(type === 'pack-group') {
      const packGroup = routeParams.pack_group
      modalContent = <PackGroupContents onLightboxShowcase={showcaseLightbox} pack_group={packGroup}/>
    }

    return (
      <>
      { isShowing && 
        <Popup 
          open={isShowing}
          onClose={hideModal}
          closeOnEscape={true}
        >
          <div>
            { lightboxImage ?
            <Lightbox keyboardInteraction={true} image={lightboxImage} title={lightboxTitle} onClose={endCoverShowcase} allowZoom={false} allowRotate={false} />
            : null }
            <div className="modal">
              <a className="close" href="#close" onClick={hideModal}>
                &times;
              </a>
              {modalContent ? modalContent : null}
            </div>
          </div>
        </Popup>
      }
      </>
    );
}
export default Modal
